import { CloudStudentProgressPage } from './CloudStudentProgressPage';
import { env } from '../../lib/env';
import { formatClock, formatDuration } from '../../features/pilotMath/format';
import { pilotSummary, resetPilotState } from '../../features/pilotMath/store';
import { usePilotState } from '../../features/pilotMath/usePilotState';
import { InkPreview } from '../../features/ink/InkPreview';
import { StudentNotesPanel } from '../../features/notes/StudentNotesPanel';
import { usePilotLearnerRecord } from '../../features/pilotMath/usePilotLearnerRecord';
import { flattenLearnerAttempts, learnerHistorySummary } from '../../features/pilotMath/learnerHistory';

function LocalStudentProgressPage() {
  const [state] = usePilotState();
  const summary = pilotSummary(state);
  const learner = usePilotLearnerRecord();
  const historySummary = learnerHistorySummary(learner);
  const allAttempts = flattenLearnerAttempts(learner);
  const visibleSkills = Object.values(learner.progress).filter((skill) => skill.evidenceCount > 0 || skill.masteryPercent >= 70);

  return (
    <div className="stack">
      <div><h1>Progress Matematika</h1><p className="muted">Current record dan history pilot disimpan terpisah.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>First-attempt hari ini</span><strong>{summary.firstAttemptAccuracy}%</strong></div>
        <div className="metric"><span>Hari belajar tersimpan</span><strong>{historySummary.learningDays}</strong></div>
        <div className="metric"><span>Waktu aktif kumulatif</span><strong>{formatDuration(historySummary.totalActiveMs)}</strong></div>
      </section>
      <section className="card">
        <h2>Current skill record</h2>
        <div className="skill-list">
          {visibleSkills.map((skill) => (
            <div className="skill-row" key={skill.skillCode}>
              <div><strong>{skill.label}</strong><div className="muted skill-code">{skill.skillCode}</div></div>
              <div className="skill-mastery"><strong>{skill.masteryPercent}%</strong><span className="muted">{skill.state.replaceAll('_', ' ')}</span></div>
            </div>
          ))}
        </div>
      </section>
      <section className="card">
        <h2>History pengerjaan hari ini</h2>
        {allAttempts.length === 0 ? <p className="muted">Belum ada history pengerjaan.</p> : (
          <div className="history-list">
            {allAttempts.slice(0, 30).map((attempt) => (
              <article className="history-item" key={`${attempt.learningDate}-${attempt.id}`}>
                <div><strong>{attempt.prompt}</strong><div className="muted">{attempt.learningDate} · {attempt.skillLabel}</div></div>
                <div className="history-item__detail">
                  <span>{attempt.firstAttemptCorrect ? '✓ benar pertama' : `${attempt.firstResponse} → ${attempt.finalResponse} ✓`}</span>
                  <span>{formatDuration(attempt.duration.activeDurationMs)}</span>
                  <span>{formatClock(attempt.completedAt)}</span>
                  <span>mastery {attempt.previousMastery}% → {attempt.newMastery}%</span>
                  {attempt.misconceptionSignals?.map((signal) => <span key={signal.code}>⚠ {signal.code}</span>)}
                </div>
                {attempt.ink && attempt.ink.strokes.length > 0 && (
                  <details className="ink-history"><summary>Lihat tulisan ({attempt.ink.strokes.length} stroke)</summary><InkPreview document={attempt.ink} /></details>
                )}
              </article>
            ))}
          </div>
        )}
      </section>
      <StudentNotesPanel studentId={state.student.id} viewerRole="student" authorName={state.student.displayName} title="Catatan yang dibagikan kepada saya" />
      <section className="card demo-tool no-print">
        <h2>Alat demo</h2>
        <p className="muted">Reset hanya menghapus data pilot di browser ini, bukan database production.</p>
        <button className="btn" type="button" onClick={() => { resetPilotState(); window.location.reload(); }}>Reset pilot hari ini</button>
      </section>
    </div>
  );
}


export function StudentProgressPage() {
  if (env.supabaseUrl && env.supabasePublishableKey) return <CloudStudentProgressPage />;
  return <LocalStudentProgressPage />;
}
